import { camelizeKeys } from "humps";
import { StoreMetadata, InformationBar } from "@commons-monorepo/index";

export const informationBarIconMatch = (mobileIcon: string) => {
  switch (mobileIcon) {
    case "clock-light":
      return "clock";
    case "truck-light":
      return "truck";
    case "t-shirt-light":
      return "light-tshirt";
    case "percent-light":
      return "light-percent";
    case "map-pin-line-light":
      return "map-pin-line";
    case "star-light":
      return "line-start";
    case "bank-light":
      return "bank";
    case "credit-card-light":
      return "credit-card";
    default:
      return mobileIcon;
  }
};

export const mapInformationBar = (
  storeMetadata: StoreMetadata,
  searchParams: URLSearchParams,
) => {
  const informationBarData = {
    informationBar: storeMetadata.informationBar,
    informationBarOffer: storeMetadata.informationBarOffer,
  };
  if (informationBarData.informationBar) {
    informationBarData.informationBar = {
      ...informationBarData.informationBar,
      ...(informationBarData.informationBar
        ? {
            selectedIcon: informationBarIconMatch(
              informationBarData.informationBar.selectedIcon,
            ),
          }
        : {}),
    };
  }

  const previewInformationBar = searchParams.get("information-bar");
  if (previewInformationBar) {
    try {
      const previewInformationBarJson = camelizeKeys(
        JSON.parse(previewInformationBar),
      ) as unknown as InformationBar;
      informationBarData.informationBar = {
        ...previewInformationBarJson,
        ...(previewInformationBarJson
          ? {
              selectedIcon: informationBarIconMatch(
                previewInformationBarJson.selectedIcon,
              ),
            }
          : {}),
      };
      informationBarData.informationBarOffer = {
        title: searchParams.get("information-bar-offer") || "",
      };
    } catch {}
  }

  return {
    informationBar: informationBarData.informationBar,
    informationBarOffer: informationBarData.informationBarOffer,
  };
};
